import React from 'react';
import { getPricing, fmtPrice, formatSaleEnds } from '../../utils/pricing';

// Renders the current price, with a strikethrough "was" price and a
// "Sale ends" line ONLY during an active, dated sale window (see
// utils/pricing.js). Outside a sale there is a single price, no strikethrough -
// a permanent "was" price nobody ever charged is a fake discount.
//
// `prefix` prepends a small qualifier such as "from", for places where the
// figure is a starting price rather than the price of a specific configuration.
export default function DiscountPrice({ product, prefix }) {
  const pricing = getPricing(product);
  if (!pricing) return null;
  return (
    <div className="asg-compare-pricing">
      {prefix && <span className="asg-compare-price-prefix">{prefix}</span>}
      {pricing.original != null && (
        <span className="asg-compare-price-original">${fmtPrice(pricing.original)}</span>
      )}
      <span className="asg-compare-price">${fmtPrice(pricing.sale)}</span>
      {pricing.saleActive && pricing.saleEndsAt && (
        <span className="asg-compare-sale-ends">{formatSaleEnds(pricing.saleEndsAt)}</span>
      )}
    </div>
  );
}
